var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"92f65a04faf19814c53c34cafee3b4d91d8c87fa"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["geonosis@firework"]={id:"92f65a04faf19814c53c34cafee3b4d91d8c87fa"};
      